export const removeLocalStorage = () => {
  for (let i = 0; i <= localStorage.length - 1; i++) {
    const str = localStorage.key(i)
    if (str.indexOf(`${process.env.NEXT_PUBLIC_SERVICE_NAME}-`) === 0) {
      localStorage.removeItem(str)
    }
  }
}
